'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./baseEntity'),
    BaseEntity = _require.BaseEntity;

var _require2 = require('./projektleiter'),
    Projektleiter = _require2.Projektleiter;

var _require3 = require('../resource'),
    ForschungsprojektResource = _require3.ForschungsprojektResource;

module.exports.Forschungsprojekt = function (_BaseEntity) {
  _inherits(Forschungsprojekt, _BaseEntity);

  _createClass(Forschungsprojekt, null, [{
    key: '__name__',
    value: function __name__() {
      return 'forschungsprojekt';
    }
  }]);

  function Forschungsprojekt(data) {
    _classCallCheck(this, Forschungsprojekt);

    // this occurs when the project is pre-filled only with
    // an organisational unit
    var fromAlmostEmpty = Object.keys(data).length <= 1;

    var _this = _possibleConstructorReturn(this, (Forschungsprojekt.__proto__ || Object.getPrototypeOf(Forschungsprojekt)).call(this));

    _this._entityName = 'de.ul.fob.domain.Forschungsprojekt';
    _this.beschreibungDE = null;
    _this.beschreibungEN = null;
    _this.istFinal = false;
    _this.projektBeginn = null;
    _this.projektEnde = null;
    _this.externeProjektwebsite = null;
    _this.relevantFuerWeitere = false;
    _this.titelBeschreibungSprache = 'DEUTSCH';
    _this.titelDE = null;
    _this.titelEN = null;
    _this.uebergeordnetesProjekt = null;
    _this.verbundprojekt = false;

    _this.antragsteller = null;
    _this.foerderung = null;
    _this.mitarbeiter = null;
    _this.organisationseinheit = null;
    if (fromAlmostEmpty) {
      _this.projektleiter = [new Projektleiter({})];
    } else {
      _this.projektleiter = [];
    }
    _this.publikation = null;
    _this.sprecherhochschule = null;
    _this.weitereOrganisationseinheiten = null;
    _this.sdg = null;
    _get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'init', _this).call(_this, data);

    var extraKeys = ['primaryPublicIdent'];

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = extraKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        if (key in data) {
          _this[key] = data[key];
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return _this;
  }

  _createClass(Forschungsprojekt, [{
    key: 'toPostData',
    value: function toPostData() {
      return this.genericJSON({
        fields: ['_id', 'beschreibungDE', 'beschreibungEN', 'istFinal', 'projektBeginn', 'projektEnde', 'externeProjektwebsite', 'relevantFuerWeitere', 'titelBeschreibungSprache', 'titelDE', 'titelEN', 'uebergeordnetesProjekt', 'verbundprojekt'],
        links: ['antragsteller', 'foerderung', 'mitarbeiter', 'organisationseinheit', 'projektLeiter', 'projektleiter', 'sdg', 'sprecherhochschule', 'weitereOrganisationseinheiten']
      });
    }
  }, {
    key: 'fetchAntragsteller',
    value: function fetchAntragsteller() {
      return _get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'genericResolve', this).call(this, 'antragsteller');
    }
  }, {
    key: 'fetchFoerderung',
    value: function fetchFoerderung() {
      return _get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'genericResolve', this).call(this, 'foerderung');
    }
  }, {
    key: 'fetchMitarbeiter',
    value: function fetchMitarbeiter() {
      return _get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'genericResolve', this).call(this, 'mitarbeiter');
    }
  }, {
    key: 'fetchOrganisationseinheit',
    value: function fetchOrganisationseinheit() {
      return _get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'genericResolve', this).call(this, 'organisationseinheit');
    }
  }, {
    key: 'fetchProjektLeiter',
    value: function fetchProjektLeiter() {
      return _get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'genericResolve', this).call(this, 'projektLeiter');
    }
  }, {
    key: 'fetchPublikation',
    value: function fetchPublikation() {
      return _get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'genericResolve', this).call(this, 'publikation');
    }
  }, {
    key: 'fetchSprecherhochschule',
    value: function fetchSprecherhochschule() {
      return _get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'genericResolve', this).call(this, 'sprecherhochschule');
    }
  }, {
    key: 'fetchSdg',
    value: function fetchSdg() {
      return _get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'genericResolve', this).call(this, 'sdg');
    }
  }, {
    key: 'fetchWeitereOrganisationseinheiten',
    value: function fetchWeitereOrganisationseinheiten() {
      return _get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'genericResolve', this).call(this, 'weitereOrganisationseinheiten');
    }

    // this is normally not used, since a ForschungsprojektResource is
    // defined

  }, {
    key: 'fetchAll',
    value: function fetchAll() {
      return Promise.all([_get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'genericResolve', this).call(this, 'antragsteller'), _get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'genericResolve', this).call(this, 'foerderung'), _get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'genericResolve', this).call(this, 'mitarbeiter'), _get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'genericResolve', this).call(this, 'organisationseinheit'), _get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'genericResolve', this).call(this, 'projektleiter'), _get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'genericResolve', this).call(this, 'publikation'), _get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'genericResolve', this).call(this, 'sdg'), _get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'genericResolve', this).call(this, 'sprecherhochschule'), _get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'genericResolve', this).call(this, 'weitereOrganisationseinheiten')]);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource() {
      if (typeof ForschungsprojektResource === 'undefined') {
        return this.fetchAll();
      } else {
        return _get(Forschungsprojekt.prototype.__proto__ || Object.getPrototypeOf(Forschungsprojekt.prototype), 'fetchQuery', this).call(this, ForschungsprojektResource);
      }
    }
  }]);

  return Forschungsprojekt;
}(BaseEntity);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/forschungsprojekt.js
// module id = 9qm6
// module chunks = 0